<script lang="ts">
    import {
        VpChevronBackwardIcon,
        VpCloseIcon,
    } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import { markFiltersApplied } from '$saga/analytics';
    import CalendarFilter from '$saga/views/Search/components/drawer/PillarFiltersDrawer/CalendarFilter.svelte';
    import DestinationTreeFilter from '$saga/views/Search/components/drawer/PillarFiltersDrawer/DestinationTreeFilter.svelte';
    import PaxFilter from '$saga/views/Search/components/drawer/PillarFiltersDrawer/PaxFilter.svelte';
    import PillarFiltersSelection from '$saga/views/Search/components/drawer/PillarFiltersDrawer/PillarFiltersSelection.svelte';
    import SelectFilter from '$saga/views/Search/components/drawer/PillarFiltersDrawer/SelectFilter.svelte';
    import {
        arePillarFiltersActive,
        filtersContext,
    } from '$saga/views/Search/store';
    import { FilterType } from '$saga/views/Search/types';

    export let selectedFilterType,
        handleSelectedFilter,
        pillarFiltersMenuTitle: string,
        title,
        close,
        resetView;

    let sectionRef: HTMLDivElement | undefined;
</script>

<section class="flex h-full flex-col overflow-hidden">
    <!--HEADER -->
    <div
        class="sticky top-0 mx-l flex min-h-[65px] items-center justify-between border-b border-solid border-border-quiet bg-white px-l py-m desktop:px-3xl"
    >
        {#if selectedFilterType !== FilterType.SELECTION}
            <button on:click={() => handleSelectedFilter(FilterType.SELECTION)}>
                <span class="size-xl text-content-neutral">
                    <VpChevronBackwardIcon />
                </span>
            </button>
        {/if}
        <h2 class="font-semibold" {...$title} use:title>
            {pillarFiltersMenuTitle}
        </h2>
        <button
            {...$close}
            use:close
            aria-label={trans('action.close')}
            on:click={() => resetView()}
        >
            <VpCloseIcon class="size-xl" />
        </button>
    </div>
    <!-- CONTENT -->
    <div
        bind:this={sectionRef}
        class="no-scrollbar flex flex-1 flex-col overflow-y-auto px-l desktop:px-3xl"
    >
        {#if selectedFilterType === FilterType.SELECTION}
            <PillarFiltersSelection {handleSelectedFilter} />
        {:else if selectedFilterType === FilterType.SPORT}
            <SelectFilter
                defaultList={$filtersContext?.defaultSportOptions?.filter(
                    (sport) => !sport.hidden,
                ) ?? []}
                displayedList={$filtersContext?.defaultSportOptions
                    ?.filter((sport) => !sport.hidden)
                    .sort((a, b) => b.count - a.count) ?? []}
                handleValidateSelection={() => {
                    markFiltersApplied();
                    resetView();
                }}
                bind:values={$filtersContext.formValues.theme}
                bind:labels={$filtersContext.formLabels.theme}
                placeholder={trans('search.bar.search_sport_placeholder')}
                allLabel={trans('search.bar.see_all_sports')}
                enableAlphabeticalGrouping={!arePillarFiltersActive}
                filterType="sport"
            />
        {:else if selectedFilterType === FilterType.DESTINATION}
            <DestinationTreeFilter
                tree={$filtersContext?.defaultDestinationOptions ?? []}
                handleValidateSelection={() => {
                    markFiltersApplied();
                    resetView();
                }}
                bind:values={$filtersContext.formValues.destination}
                bind:labels={$filtersContext.formLabels.destination}
                placeholder={trans('search.bar.search_destination_placeholder')}
                allLabel={trans('search.bar.see_all_destinations')}
            />
        {:else if selectedFilterType === FilterType.PAX}
            <PaxFilter
                handleValidateSelection={() => {
                    markFiltersApplied();
                    resetView();
                }}
            />
        {:else if selectedFilterType === FilterType.STARTDATE}
            <CalendarFilter
                handleValidateSelection={() => {
                    markFiltersApplied();
                    resetView();
                }}
                overflowContainer={sectionRef}
            />
        {/if}
    </div>
</section>
